import {Subscribable} from './subscribable';

export class BaseViewModel extends Subscribable {
  public init() {};
}
